import { TableActions } from '@core/components/Table';
import { permissaoUtils } from '@core/util/permissaoUtil';
import DeleteIcon from '@material-ui/icons/Delete';
import React, { useContext } from 'react';
import { FaPlus } from 'react-icons/fa';
import { VendedorContext } from '../../VendedorContext';
import { vendedorModais } from '../modal/vendedorModais';

const VendedorFab = ({ onDelete }) => {
  const [, setModal] = useContext(VendedorContext).modal;
  const [selecao] = useContext(VendedorContext).selecao;
  const [tipoSelecao] = useContext(VendedorContext).tipoSelecao;
  const [, setVendedorAtual] = useContext(VendedorContext).vendedorAtual;

  const existeSelecionados = selecao.length > 0 || tipoSelecao !== 'NENHUM';

  const triggerCreate = (modal) => {
    setVendedorAtual({});
    setModal(modal);
  };

  const triggerDelete = () => {
    onDelete({ ids: selecao, q: '', tipoSelecao });
  };

  const actions = [
    {
      icon: <DeleteIcon />,
      name: 'delete',
      tooltip: 'Excluir',
      show: permissaoUtils.vendedor().excluir && existeSelecionados,
      onClick: triggerDelete,
    },
    {
      icon: <FaPlus />,
      name: 'createVendedor',
      tooltip: 'Cadastrar',
      show: permissaoUtils.vendedor().cadastrar,
      onClick: () => triggerCreate(vendedorModais.cadastroVendedor),
    },
  ];

  return <TableActions actions={actions} />;
};

export default VendedorFab;
